import { Typography } from '@musinsa/mds';

interface EmptyStateProps {
  title: string;
  subTitle?: string;
  height?: number;
}

export const EmptyState = ({ title, subTitle, height }: EmptyStateProps) => (
  <div
    className="flex flex-col items-center justify-center gap-1 w-full"
    style={height ? { height } : undefined}
  >
    <Typography variant="body14pxMed" colorScheme="black">
      {title}
    </Typography>
    {subTitle && (
      <Typography variant="body13pxReg" colorScheme="gray-600">
        {subTitle}
      </Typography>
    )}
  </div>
);
